export enum ActiveLoanStatus {
  incomplete = `Incomplete`,
  applied = `Applied and waiting for response from 3rd Party`,
  denied = `Denied`,
  approved_with_stipulations = `Approved with stipulations`,
  approved = `Approved`,
}

export enum UploadStatus {
  none = `none`,
  pending = `pending`,
  success = `success`,
  failure = `failure`,
}

export enum EdgeType {
  eave = `eave`,
  ridge = `ridge`,
  rake = `rake`,
  hip = `hip`,
  valley = `valley`,
}

export enum LoanProvider {
  mosaic = `mosaic`,
  goodleap = `goodleap`,
  sunlight = `sunlight`,
  sungage = `sungage`,
  enfin = `enfin`,
  concert = `concert`,
  lightreach = `lightreach`,
  credit_human = `credit_human`,
}

export enum ImagerySource {
  nearmap = `nearmap`,
  pictometry = `pictometry`,
  google = `google`,
  bing = `bing`,
}

export enum DesignSource {
  vision = `vision`,
  aurora = `aurora`,
}

export enum ProposalKind {
  solar = `solar`,
  battery_only = `battery_only`,
}

export enum ProposalAuditEventType {
  created = `created`,
  updated = `updated`,
  published = `published`,
  max_fit_requested = `max_fit_requested`,
  max_fit_completed = `max_fit_completed`,
}

export enum ProposalStatusType {
  proposal_created = `Proposal Created`,
  design_queued = `Design Queued`,
  design_underway = `Design Underway`,
  design_complete = `Design Complete`,
  design_failed = `Design Failed`,
  design_rejected = `Design Rejected`,
  proposal_published = `Proposal Published`,
  contract_sent = `Contract Sent`,
  contract_signed = `Contract Signed`,
  summary_confirmed = `Summary Confirmed`,
}

export enum SystemType {
  roof_mount = `roof mount`,
  ground_mount = `ground mount`,
  both = `both`,
}

export enum Permission {
  active_subscribers = `active_subscribers`,
  admin = `admin`,
  ambassador = `ambassador`,
  api_key_admin = `api_key_admin`,
  careers_administrator = `careers_administrator`,
  commission_specialist = `commission_specialist`,
  comped_subscribers = `comped_subscribers`,
  consultants = `consultants`,
  designer_user = `designer_user`,
  energy = `energy`,
  enterprise_admin = `enterprise_admin`,
  enterprise_admin_pro = `enterprise_admin_pro`,
  enterprise_comped = `enterprise_comped`,
  enterprise_consultant = `enterprise_consultant`,
  enterprise_manager = `enterprise_manager`,
  enterprise_owner = `enterprise_owner`,
  enterprise_owner_pro = `enterprise_owner_pro`,
  enterprise_super_admin = `enterprise_super_admin`,
  enterprise_support = `enterprise_support`,
  equipment_admin = `equipment_admin`,
  finance = `finance`,
  financing_admin = `financing_admin`,
  former_ambassador = `former_ambassador`,
  guest = `guest`,
  homeowner = `homeowner`,
  installer = `installer`,
  inv = `inv`,
  lead_generator = `lead_generator`,
  licenses_administrator = `licenses_administrator`,
  marketing_staff = `marketing_staff`,
  mentorship_assignment = `mentorship_assignment`,
  open_solar_designer = `open_solar_designer`,
  ops_support = `ops_support`,
  opsmanager = `opsmanager`,
  org_mentor_access = `org_mentor_access`,
  platform_admins = `platform_admins`,
  platform_communications = `platform_communications`,
  proposal_admin = `proposal_admin`,
  proposal_creation = `proposal_creation`,
  proposal_read = `proposal_read`,
  sales_org = `sales_org`,
  sales_pro = `sales_pro`,
  sales_support = `sales_support`,
  service_bureau_admin = `service_bureau_admin`,
  service_bureau_user = `service_bureau_user`,
  serviceareaupdater = `serviceareaupdater`,
  user_admin = `user_admin`,
  vision_admin = `vision_admin`,
  vision_api_key_admin = `vision_api_key_admin`,
  vision_designer_user = `vision_designer_user`,
  vision_developer = `vision_developer`,
  vision_equipment_admin = `vision_equipment_admin`,
  vision_financing_admin = `vision_financing_admin`,
  vision_proposal_admin = `vision_proposal_admin`,
  vision_service_bureau_admin = `vision_service_bureau_admin`,
  vision_service_bureau_user = `vision_service_bureau_user`,
  vision_user_admin = `vision_user_admin`,
  tier_2_vision_designer = `tier_2_vision_designer`,
  has_no_enterprise_margin_limit = `has_no_enterprise_margin_limit`,
  can_view_enterprise_proposal_pricing_breakdown = `can_view_enterprise_proposal_pricing_breakdown`,
  may_use_lower_enterprise_margin_limit = `may_use_lower_enterprise_margin_limit`,
  can_reset_design = `can_reset_design`,
  limited_demo = `limited_demo`,
}

export enum StateCode {
  AK = `AK`,
  AL = `AL`,
  AR = `AR`,
  AZ = `AZ`,
  CA = `CA`,
  CO = `CO`,
  CT = `CT`,
  DC = `DC`,
  DE = `DE`,
  FL = `FL`,
  GA = `GA`,
  HI = `HI`,
  IA = `IA`,
  ID = `ID`,
  IL = `IL`,
  IN = `IN`,
  KS = `KS`,
  KY = `KY`,
  LA = `LA`,
  MA = `MA`,
  MD = `MD`,
  ME = `ME`,
  MI = `MI`,
  MN = `MN`,
  MO = `MO`,
  MS = `MS`,
  MT = `MT`,
  NC = `NC`,
  ND = `ND`,
  NE = `NE`,
  NH = `NH`,
  NJ = `NJ`,
  NM = `NM`,
  NV = `NV`,
  NY = `NY`,
  OH = `OH`,
  OK = `OK`,
  OR = `OR`,
  PA = `PA`,
  PR = `PR`,
  RI = `RI`,
  SC = `SC`,
  SD = `SD`,
  TN = `TN`,
  TX = `TX`,
  UT = `UT`,
  VA = `VA`,
  VT = `VT`,
  WA = `WA`,
  WI = `WI`,
  WV = `WV`,
  WY = `WY`,
}
